//TODO: split up into common controls and advanced controls?

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms'; //is this needed here.  can we/should we export from the app module?
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbModalModule, NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
//import { DebugModule } from 'src/app/debug/debug.module';
import { PipeModule } from '@Shared/Pipes/proprietary/pipe.module';
import { DirectiveModule } from '../../../../../Shared/Directives/proprietary/directive.module';
import { ActionMenuComponent } from './action-menu.component';
import { AddressComponent } from './address.component';
import { CollectionColumnDragDropDirective } from './collection-control/collection-column-drag-drop.directive';
import { CollectionColumnSortableDirective } from './collection-control/collection-column-sortable.directive';
import { CollectionDynamicComponentAnchorDirective } from './collection-control/collection-dynamic-component-anchor.directive';
import { CollectionDynamicComponent } from './collection-control/collection-dynamic-component.component';
import { CollectionDynamicTemplateComponent } from './collection-control/collection-dynamic-template.component';
import { CollectionGridHeightDirective } from './collection-control/collection-grid-height.directive';
import { CollectionColumnResizeComponent } from './collection-control/collection-resize-column.component';
import { ResizableDirective } from './collection-control/collection-resize-column.directive';
import { CollectionComponent } from './collection-control/collection.component';
import { ExportToCsvComponent } from './collection-control/data-export/export-to-csv.component';
import { CollectionVirtualScrollingModule } from './collection-control/virtual-scroll/collection-virtual-scroll.module';
import { DataServiceErrorComponent } from './dataservice-error.component';
import { DropdownComponent } from './dropdown.component';
import { EmailComponent } from './email.component';
import { EntityCommentsComponent } from './entity-comments.component';
import { FavoriteComponent } from './favorite.component';
import { FilterInputComponent } from './filter-input.component';
import { HighchartComponent } from './highcharts.component';
import { InstallmentPlanDirective } from './installment-plan.directive';
import { MaxRowWarningComponent } from './max-row-warning.component';
import { MultiTabContextMenuComponent } from './multi-tab-context-menu.component';
import { RowComponent } from './page-row.component';
import { PageComponent } from './page.component';
import { PaginateComponent } from './paginate.component';
import { PanelComponent } from './panel.component';
import { PhoneComponent } from './phone.component';
import { SectionControlModule } from './section-controls/section-control.module';
import { SelectorComponent } from './selector.component';
import { SimpleIndicatorComponent } from './simple-indicator.component';
import { SmAlertComponent } from './sm-alert/sm-alert.component';
import { SmCardComponent } from './sm-card/sm-card.component';
import { SmCheckboxComponent } from './sm-checkbox/sm-checkbox.component';
import { SmSwitchComponent } from './sm-switch/sm-switch.component';
import { UrgentCommentComponent } from './urgent-comment.component';
import { UxDesignerPageHeaderComponent } from './ux-designer-controls/ux-designer-page-header/ux-designer-page-header.component';
import { UxDesignerTemplatePanelComponent } from './ux-designer-controls/ux-designer-template-panel/ux-designer-template-panel.component';
import { WebsiteComponent } from './website.component';
import { SharedModule } from '@Shared/shared.module';
@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        RouterModule,
        NgbTooltipModule,
        NgbDropdownModule,
        NgbModalModule,
        NgbModule,
        DirectiveModule,
        //DebugModule,
        PipeModule,
        SectionControlModule,
        CollectionVirtualScrollingModule,
        SharedModule
    ],
    declarations: [
        UxDesignerPageHeaderComponent,
        UxDesignerTemplatePanelComponent,
        DropdownComponent,
        SelectorComponent,
        SimpleIndicatorComponent,
        DataServiceErrorComponent,
        ActionMenuComponent,
        HighchartComponent,
        CollectionComponent,
        PanelComponent,
        PageComponent,
        RowComponent,
        FavoriteComponent,
        EmailComponent,
        PhoneComponent,
        AddressComponent,
        WebsiteComponent,
        FilterInputComponent,
        UrgentCommentComponent,
        EntityCommentsComponent,
        MaxRowWarningComponent,
        PaginateComponent,
        InstallmentPlanDirective,
        ResizableDirective,
        CollectionColumnResizeComponent,
        CollectionColumnDragDropDirective,
        CollectionColumnSortableDirective,
        CollectionGridHeightDirective,
        CollectionDynamicTemplateComponent,
        CollectionDynamicComponentAnchorDirective,
        CollectionDynamicComponent,
        MultiTabContextMenuComponent,
        ExportToCsvComponent,
        SmCardComponent,
        SmCheckboxComponent,
        SmSwitchComponent,
        SmAlertComponent
    ],
    exports: [
        UxDesignerPageHeaderComponent,
        UxDesignerTemplatePanelComponent,
        DropdownComponent,
        SelectorComponent,
        SimpleIndicatorComponent,
        DataServiceErrorComponent,
        ActionMenuComponent,
        HighchartComponent,
        CollectionComponent,
        PanelComponent,
        PageComponent,
        RowComponent,
        FavoriteComponent,
        EmailComponent,
        PhoneComponent,
        AddressComponent,
        WebsiteComponent,
        FilterInputComponent,
        UrgentCommentComponent,
        EntityCommentsComponent,
        MaxRowWarningComponent,
        PaginateComponent,
        InstallmentPlanDirective,
        ResizableDirective,
        CollectionColumnResizeComponent,
        CollectionColumnDragDropDirective,
        CollectionColumnSortableDirective,
        CollectionGridHeightDirective,
        CollectionDynamicTemplateComponent,
        CollectionDynamicComponentAnchorDirective,
        CollectionDynamicComponent,
        MultiTabContextMenuComponent,
        ExportToCsvComponent,
        SmCardComponent,
        SmCheckboxComponent,
        SmSwitchComponent,
        SmAlertComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ControlModule { }
